import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type {
    ApiAvDivisionSection,
    ApiDivisionSection,
    ApiDivisionSectionAvailableParams,
    ApiDivisionSectionFilter,
} from "./types";

interface DivisionSectionsListResponse {
    sections: ApiDivisionSection[];
}

interface AvSectionsListResponse {
    sections: ApiAvDivisionSection[];
}

/**
 * Транспортный слой OMP — участки (таблица sections + avSections). \
 * Для участков в контексте подразделения используйте {@link divisionSectionApi.loadAvailable}.
 */
export const divisionSectionApi = {
    /**
     * Загружает участки по фильтру. \
     * Запрос уходит в endpoint `sections.loadByFilter`.
     * @param params параметры фильтрации
     * @param config конфигурация HTTP-запроса
     * @returns список участков
     */
    load: async (params: { flt?: ApiDivisionSectionFilter }, config?: RequestConfig): Promise<ApiDivisionSection[]> => {
        const data = await ompApiClient.postOmega<DivisionSectionsListResponse>("sections.loadByFilter", params, config);
        return data.sections;
    },

    /**
     * Загружает доступные участки для контекста подразделения. \
     * Endpoint `divisions/storeDivisions.avSections`, тело `{"params":{…}}`.
     * @param params контекст выбора ({@link ApiDivisionSectionAvailableParams})
     * @param config конфигурация HTTP-запроса
     * @returns список `{ code, name }`
     */
    loadAvailable: async (
        params: ApiDivisionSectionAvailableParams,
        config?: RequestConfig,
    ): Promise<ApiAvDivisionSection[]> => {
        const data = await ompApiClient.postOmega<AvSectionsListResponse>(
            "divisions/storeDivisions.avSections",
            { params },
            config,
        );
        return data.sections;
    },
} as const;
